import script from "./dateRangePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./dateRangePicker.vue?vue&type=script&setup=true&lang=js"

import "./dateRangePicker.vue?vue&type=style&index=0&id=21c27a83&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21c27a83"]])

export default __exports__